import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName = 'deployment'

export function selectAll(parameter) {
  console.log('params:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOne(type,companyId) {
  console.log('type:', type,companyId)
  return axios({
    url: `/ws/${moduleName}/${type}/${companyId}`,
    method: 'get'
  })
}

export function selectDepNamesByLoginUser(accountId) {
  return axios({
    url: `/ws/${moduleName}/selectDepNamesByLoginUser/${accountId}`,
    method: 'get'
  })
}

export function insert(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data: parameter
  })
}

export function update(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data: parameter
  })
}


export function deleteObj(ids) {
  console.log('ids', ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params: ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export default {
  selectAll,
  selectOne,
  update,
  selectDepNamesByLoginUser,
  save: insert,
  delete: deleteObj
}